import { Button, Input, LayoutHeader, Panel, Switch, TextArea, Toggle } from '@swivl-mono/ui';
import RolesModel from '../../../Models/Roles/Roles.Model';
import { useNavigate, useParams } from 'react-router-dom';
import {
  APIScope,
  APIScopePermission,
  RoleInterface,
} from '@swivl-mono/types';
import { Member } from '../../../Models/Member/Member.Current';
import { PermissionsGroupSection } from './Components/PermissionsGroupSection';



export interface ActionAndName {
  action: APIScope;
  label: string;
}

interface Props {
  role: RoleInterface
}

export function RoleSettingsDetailsView(props: Props) {
  const { role } = props;
  const { roles, parentRoles } = RolesModel.useState();
  const navigate = useNavigate();
  // const params = useParams();
  // const roleId = params.roleId;
  // if (!role) return <div>Loading...</div>;

  // let role:RoleInterface | undefined = undefined;
  // if (roleId) {
  //   for (let key in roles) {
  //     if (roles[key].id === parseInt(roleId)) {
  //       role = roles[key];
  //     }
  //   }
  //   if (!role) {
  //     for (let key in parentRoles) {
  //       if (parentRoles[key].id === parseInt(roleId)) {
  //         role = parentRoles[key];
  //       }
  //     }
  //   }
  // }

  /*  "fms-edit": "allowed",
    "fms-view": "allowed",
    "apps-edit": "allowed",
    "logged-in": "allowed",
    "roles-get": "allowed",
    "roles-set": "allowed",
    "local-only": "allowed",
    "roles-view": "allowed",
    "members-get": "allowed",
    "members-set": "allowed",
    "reviews-view": "allowed",
    "location-view": "allowed",
    "user-crm-view": "allowed",
    "user-crm-write": "allowed",
    "sequences-edit": "allowed",
    "sequences-view": "allowed",
    "user-crm-write": "allowed",
    "workflows-edit": "allowed",
    "workflows-view": "allowed",
    "location-create": "allowed",
    "escalations-edit": "allowed",
    "super-admin-only": "allowed",
    "conversation-view": "allowed",
    "escalations-handle": "allowed",
    "locations-all-view": "allowed",
    "conversation-takeover": "allowed",
    "location-details-read": "allowed",
    "location-details-write": "allowed"
    */





  if (!role) return <div>Role Not Found</div>;

  const readOnly = role.orgId !== Member.orgId;

  const isParentAndOwner = Member.isInParentOrg && role.orgId === Member.orgId;

  return (
    <div className="flex flex-col px-6 pb-6">
      <LayoutHeader noPadding={true}><h2>Role Details </h2>
        <Button onClick={async () => {
          if (window.confirm("Are you sure you want to delete this role?")) {
            await RolesModel.deleteRole(role.id);
            navigate('/settings/roles');
          }
        }}>Delete Role</Button>

      </LayoutHeader>
      <label>Display Name</label>

      <Input value={role.name} readOnly={readOnly}
        onChange={(e) => {
          let updatedRole = { ...role };
          updatedRole.name = e.target.value;
          RolesModel.updateRole(updatedRole);
        }}
      />
      <label>Description</label>
      <TextArea value={role.description}
        className='mb-6'
        readOnly={readOnly}
        onChange={(e) => {
          let updatedRole = { ...role };
          updatedRole.description = e.target.value;
          RolesModel.updateRole(updatedRole);
        }}
      />

      <PermissionsGroupSection
        heading="Locations"
        role={role}
        readOnly={readOnly}
        isParentAndOwner={isParentAndOwner}
        actions={[
          { label: 'View Locations', action: APIScope.LOCATIONS_ALL_VIEW },
        ]}
      />

      <PermissionsGroupSection
        heading="Members"
        role={role}
        readOnly={readOnly}
        isParentAndOwner={isParentAndOwner}
        actions={[
          { label: 'View Members', action: APIScope.MEMBERS_GET },
          { label: 'Manage Members', action: APIScope.MEMBERS_SET },
        ]}
      />

      <PermissionsGroupSection
        heading="Manage"
        role={role}
        readOnly={readOnly}
        isParentAndOwner={isParentAndOwner}
        actions={[
          { label: 'View Roles', action: APIScope.ROLES_VIEW },
          { label: 'Write Roles', action: APIScope.ROLES_SET },
          { label: 'Edit Escalation Groups', action: APIScope.ESCALATIONS_EDIT },
          { label: 'View Workflows', action: APIScope.WORKFLOWS_VIEW },

        ]}
      />




      <PermissionsGroupSection
        heading="Conversations"
        role={role}
        readOnly={readOnly}
        isParentAndOwner={isParentAndOwner}
        actions={[
          { label: 'Handle Escalations', action: APIScope.ESCALATIONS_HANDLE },
          { label: 'View Conversations', action: APIScope.CONVERSATION_VIEW },
        ]}
      />
    </div>
  );
}

